<template>
  <base-section id="about-our-product-and-services">
    <base-section-heading
      color="grey lighten-2"
      title="Products and Services"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: 'SectionAboutOurProductAndServices',

  data: () => ({
    cards: [
      {
        title: 'Know Your Quality',
        subtitle: 'Long-standing Business',
        text: 'At it\'s heart, Helderberg Propshaft strives to repair and service of all types of Propshafts, remaining a leading service provider for the automotive industry.',
        callout: '01',
      },
      {
        title: 'Experience',
        subtitle: 'Wider Industry',
        text: 'Designing and manufacturing specialized propshafts and related parts in the wider industry is not uncommon to Helderberg Propshaft. Packaging and Bottling plants, the Printing and Weaving Industry and many more stand alone factories where a Cardan shaft is needed',
        callout: '02',
      },
      {
        title: 'Supply Parts',
        subtitle: 'Affordable Prices',
        text: 'Carrying a wide range of Propshaft spare parts and Centre Bearings for most off the vehicles and construction vehicles on the South African market. Strange and once off parts can be ordered overnight. All Universal Joints listed world wide can be sourced from our suppliers.',
        callout: '03',
      },
    ],
  }),
};
</script>
